import { defineStore } from 'pinia'

export const useFormCommentStore = defineStore('formcomment', {
    state: () => ({
        form: {
            comment: '',
            files: []
        },
        requestedFocus: null,
        lastRequestTime: 0
    }),
    actions: {
        requestFocus(componentId) {
            this.requestedFocus = componentId;
            this.lastRequestTime = Date.now();
        },
        clearRequest() {
            this.requestedFocus = null;
        }
    }
})